<!DOCTYPE html>
<html lang="en">
    <head>
        <title>Octopus Deploy</title>
        <link rel="apple-touch-icon" href="./app/images/favicon.png" />
        <link rel="icon" href="./app/images/favicon.png" />
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width" />

        <style>
            html {
                font-size: 100%;
                min-height: 100%;
            }

            body {
                position: relative;
                min-height: 100%;
                font-size: 1rem;
                font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", "Oxygen Sans", Ubuntu, sans-serif;
                margin: 0;
                padding: 0;
                background: #fafafa;
                line-height: 1.25rem;
            }

            .app-container {
                height: 100%;
            }

            .OctopusLoader {
                display: flex;
                align-items: center;
                height: 100vh;
                justify-content: center;
                flex-direction: column;
            }

            .fatal-error {
                background-color: #fbeceb;
                font-size: 0.875rem;
                color: #db4437;
                padding: 1rem;
                margin-top: 1.2rem;
                border-radius: 10px;
                border: 3px solid rgb(209, 192, 192);
                text-align: center;
            }

            #outdated {
                display: none;
            }

            .outdated-message {
                text-align: center;
            }
        </style>
    </head>
    <body>
        <div id="app" class="app-container">
            <div id="outdated" class="fatal-error"><p class="outdated-message"></p></div>
            <div class="OctopusLoader">
                <noscript>
                    <div class="fatal-error">
                        <strong>JavaScript must be enabled</strong>
                        <p>
                            You must enable JavaScript in your browser for Octopus Deploy to work. Here are the
                            <a href="https://www.enable-javascript.com/" target="_blank" rel="noopener noreferrer"> instructions how to enable JavaScript in your web browser</a>.
                        </p>
                    </div>
                </noscript>
            </div>
        </div>
        <!-- Vite will inject the app entry point here -->
        <script type="module" src="./app/index.tsx"></script>
    </body>
</html>
